import { Button } from "@cur8/maneki";
import { Banner } from "render/ui/presentation/Banner";

interface ScheduleUnavailableProps {
  onRetry(): void;
}

/**
 * Shown when today's schedule could not be loaded at all.
 *
 * Deliberately not the empty state: "no visits today" would tell an operator
 * the day is clear when it is only unreadable, and sends them looking for a
 * booking that is fine.
 */
export function ScheduleUnavailable({ onRetry }: ScheduleUnavailableProps) {
  return (
    <Banner
      kind="error"
      size="l"
      action={
        <Button variant="secondary" onPress={onRetry}>
          Retry
        </Button>
      }
    >
      Today&apos;s schedule could not be loaded. This is not the same as an
      empty day, so check with support before sending anyone away.
    </Banner>
  );
}
